import React, { useState, useEffect, useMemo } from 'react';
import styles from './ZombiePurgeHeader.module.scss';
import { RARIBLE_LINKS } from 'src/base/constants';
import Image from 'next/image';
import { ActionButton, Link } from 'src/ui/components';

export default function ZombiePurgeHeader({ purgeStarted, purgeStart }) {
	const [minutesLeft, setMinutesLeft] = useState( null );

	useEffect( () => {
		if ( purgeStarted ) return;
		if ( !purgeStart ) return;
		const intervalId = setInterval( () => {
			const secondsLeft = ( purgeStart - Date.now() ) / 1000;
			const truncated = Math.trunc( secondsLeft / 60 );
			setMinutesLeft( truncated );
		}, 5000 );
		return () => clearInterval( intervalId );
	}, [ purgeStart ]);

	const statement = useMemo( () => {
		if ( !minutesLeft && !purgeStarted ) return 'The Zombie Purge will begin shortly';
		if ( purgeStarted ) return '';
		return `The Zombie Purge will begin in ${minutesLeft} minutes`;
	}, [minutesLeft, purgeStarted]);

	return (
		<div 
			className={`w-full bg-cover bg-center bg-no-repeat relative bg-black h-[888px]  ${styles['zombie-purge-header']}`}>
			<div className={`absolute w-full h-full top-0 right-0  z-[1] ${styles['zombie-purge-header-overlay']}`}/>
			<div className={`max-[1000px]:flex-col max-[1000px]:items-center flex justify-center relative  z-[2] w-full ${styles['zombie-purge-header-text']}`}>
				<div className={`max-[1000px]:w-8/12 w-6/12 ${styles['zombie-purge-header-text-left-side']}`}>
					<Image 
						className="m-0 p-0"
						src="/images/ZombiePurge/purge_logo.png" 
						width={585} 
						height={360}
					/>
				</div>
				<div className={`max-[1000px]:w-8/12 w-4/12 flex flex-col pt-20 justify-start items-center max-w-[346px] ${styles['zombie-purge-header-text-right-side']}`}>
					<Image 
						src="/images/ZombiePurge/purge_eyes.png" 
						width={122} 
						height={122}
					/>
					<h2 className={`max-[500px]:text-2xl -f-family-chauncy text-3xl leading-relaxed m-0 mt-6 mb-2 text-center font-bold uppercase ${styles['zombie-purge-header-text-right-side-title']}`}>AHHHHHH! THE ZOMBIES ARE OUT OF CONTROL!</h2>
					<p className={'max-[500px]:text-xs text-sm text-center text-[#D9D9D9] font-normal leading-relaxed'}>
					The battle between the genesis Apepes and the Zombie Apepes has erupted.
						<br />
					If you are on the side of the genesis Apepes, the Zombie Purge is for you. 
					For each purge, you’ll be rewarded with “The End of the War”, which will be usable for the Apepe Rebirth.
					</p>
					<p className={'max-[500px]:text-xs text-sm text-center text-[#D9D9D9] font-normal leading-relaxed'}></p>

					<div 
						className={'flex justify-center items-center mt-5 h-auto '}
					>
						<span className="font-bold text-[#D9D9D9] max-[500px]:text-xs text-sm">
Got no zombies?
						</span> 
						<Link 	
							external
							href={RARIBLE_LINKS.ZOMBIES} >
							<ActionButton
								iconType="rarible"
								iconClassName={`mr-1.5 ${styles['zombie-purge-header-cta-icon']}`}
								textContent="Rarible"
								className={`max-[500px]:text-sm bg-none ml-4 flex items-center text-white border-white border-2 border-solid ${styles['zombie-purge-header-cta']}`}/>
						</Link>
					</div>
				</div>
			</div>
			<div className='flex items-center justify-center px-10'>
				{ !purgeStarted && ( <div className='text-2xl text-white z-50 mt-10'>
					{statement}
				</div> )}
			</div>
			<div className='text-center relative z-10 mt-14 px-10'>
				<Link href="zombie-purge/purged">
					<p className='text-white text-bold text-lg underline max-w-'>View the most recently purged Zombies</p>
				</Link>
			</div>
		</div> 
	);
}
